var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[(_vm.reportUrl !== null)?_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('h2',[_vm._v(" Go here to see reports ")]),_c('a',{attrs:{"href":_vm.reportUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.reportUrl)+" ")])])],1):_vm._e(),_c('v-row',[_c('report-wrapper')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }